module.exports = __webpack_public_path__ + "img/section3.3a59f5f0.jpg";